export const CHANGESTATEREDUCER_SET = 'set'


export const changeState = (payload) => ({
  type: CHANGESTATEREDUCER_SET,
  payload
})
